var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bumps-template',{attrs:{"comedones":_vm.comedones,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }